const C = window.KikTheme ?? {
  ready: !1,
  version: "0.1.0"
};
class L extends HTMLElement {
  connectedCallback() {
    this.initScrollAffordance(), this.links = [...this.querySelectorAll("[data-kik-nav-link]")], this.pairs = this.links.map((t) => {
      const e = t.getAttribute("href") ?? "", i = e.startsWith("#") && e.length > 1 ? document.getElementById(e.slice(1)) : null;
      return i ? { link: t, target: i } : null;
    }).filter(Boolean), this.addEventListener("click", this.onClick), this.pairs.length !== 0 && (window.addEventListener("scroll", this.onScroll, { passive: !0 }), this.onScroll());
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll), this.resizeObserver?.disconnect(), this.removeEventListener("click", this.onClick);
  }
  // Active tab = the last anchor scrolled past, i.e. the one closest to the bar without
  // being below it. Deliberately NOT IntersectionObserver: sections/kik-anchor.liquid
  // targets are zero-height markers, and an empty element only intersects while it is
  // physically inside the observed band — scroll past it and NO tab would be active.
  // Comparing rect tops handles markers and full-height sections identically, and needs
  // no assumption that nav block order matches the sections' order on the page.
  onScroll = () => {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.ticking = !1;
      const t = this.offsetHeight + 1;
      let e = null, i = -1 / 0;
      for (const n of this.pairs) {
        const { top: o } = n.target.getBoundingClientRect();
        o <= t && o > i && (i = o, e = n);
      }
      this.setActive((e ?? this.pairs[0]).link);
    }));
  };
  // Mobile tabs overflow by design; fade the right edge only while there is more to reach,
  // otherwise the hint lies once you are at the end.
  initScrollAffordance() {
    const t = this.querySelector("[data-kik-nav-scroller]");
    if (!t) return;
    const e = () => {
      const i = t.scrollWidth - t.clientWidth - t.scrollLeft;
      t.dataset.kikScrollable = i > 1 ? "true" : "false";
    };
    t.addEventListener("scroll", e, { passive: !0 }), this.resizeObserver = new ResizeObserver(e), this.resizeObserver.observe(t), e();
  }
  onClick = (t) => {
    const e = t.target.closest?.("[data-kik-nav-link]"), i = e && this.pairs.find((n) => n.link === e);
    i && (t.preventDefault(), window.scrollTo({
      top: i.target.getBoundingClientRect().top + window.scrollY - this.offsetHeight,
      behavior: "smooth"
    }), this.setActive(e));
  };
  setActive(t) {
    for (const e of this.links)
      e === t ? e.setAttribute("aria-current", "true") : e.removeAttribute("aria-current");
  }
}
customElements.get("kik-section-nav") || customElements.define("kik-section-nav", L);
class A extends HTMLElement {
  connectedCallback() {
    this.timers = [], this.observers = [], this.initGalleryLabel(), this.initGalleryZoom(), this.initCountdown(), this.initCopy(), this.initQty(), this.initVariants(), this.initBundle(), this.initVideo(), this.initStickyAtc();
  }
  disconnectedCallback() {
    for (const t of this.timers) clearInterval(t);
    for (const t of this.observers) t.disconnect();
  }
  // dev note: "Label only showing in first image". Flickity marks the active cell with
  // .is-selected but exposes no DOM event, so watch the class instead of reaching into it.
  initGalleryLabel() {
    const t = this.querySelector("[data-kik-gallery-label]"), e = this.querySelector("[data-main-media]");
    if (!t || !e) return;
    const i = () => {
      const o = e.querySelector("[data-main-slide]");
      t.hidden = !o?.classList.contains("is-selected");
    }, n = new MutationObserver(i);
    n.observe(e, { attributes: !0, attributeFilter: ["class"], subtree: !0 }), this.observers.push(n), requestAnimationFrame(i);
  }
  // The gallery's zoom button is the theme's own PhotoSwipe trigger. interactable.min.js
  // binds that click handler only inside T4SThemeSP.PhotoSwipe.gallery(), which
  // main-product.liquid's own script calls and nothing calls for this section — so the
  // button renders and silently does nothing. The handler is delegated on document, so one
  // call is enough; it is idempotent (jQuery namespaces the binding "click.pswp").
  // T4SThemeSP is a vendor global that may load after this element upgrades, hence the poll.
  initGalleryZoom() {
    if (!this.querySelector("[data-pswp-btn-triger]")) return;
    let t = 0;
    const e = setInterval(() => {
      const i = window.T4SThemeSP?.PhotoSwipe?.gallery;
      i && i(), (i || ++t > 40) && clearInterval(e);
    }, 100);
    this.timers.push(e);
  }
  initCountdown() {
    const t = this.querySelector("[data-kik-countdown]");
    if (!t) return;
    const e = Date.parse(t.dataset.endAt ?? "");
    if (Number.isNaN(e)) {
      t.hidden = !0;
      return;
    }
    const i = {
      day: t.querySelector("[data-kik-cd-day]"),
      hrs: t.querySelector("[data-kik-cd-hrs]"),
      min: t.querySelector("[data-kik-cd-min]"),
      sec: t.querySelector("[data-kik-cd-sec]")
    }, n = () => {
      const o = e - Date.now();
      if (o <= 0) {
        t.hidden = !0;
        return;
      }
      const r = Math.floor(o / 1e3), s = (c) => String(c).padStart(2, "0");
      i.day && (i.day.textContent = s(Math.floor(r / 86400))), i.hrs && (i.hrs.textContent = s(Math.floor(r % 86400 / 3600))), i.min && (i.min.textContent = s(Math.floor(r % 3600 / 60))), i.sec && (i.sec.textContent = s(r % 60));
    };
    n(), this.timers.push(setInterval(n, 1e3));
  }
  initCopy() {
    const t = this.querySelector("[data-kik-copy]");
    t && t.addEventListener("click", async () => {
      const e = t.querySelector("[data-kik-copy-label]"), i = e?.textContent;
      try {
        await navigator.clipboard.writeText(t.dataset.kikCopy ?? ""), e && (e.textContent = "COPIED");
      } catch {
        e && (e.textContent = "PRESS ⌘C");
      }
      e && setTimeout(() => {
        e.textContent = i;
      }, 2e3);
    });
  }
  initQty() {
    const t = this.querySelector("[data-kik-qty-input]");
    if (!t) return;
    const e = (i) => {
      const n = Math.max(1, (parseInt(t.value, 10) || 1) + i);
      t.value = String(n), t.dispatchEvent(new Event("change", { bubbles: !0 }));
    };
    this.querySelector("[data-kik-qty-minus]")?.addEventListener("click", () => e(-1)), this.querySelector("[data-kik-qty-plus]")?.addEventListener("click", () => e(1));
  }
  // Options come from the product's real option values, so the design's colour names are
  // never assumed. Matching is positional against variants.options.
  initVariants() {
    const t = this.querySelector("[data-kik-variant-picker]"), e = this.querySelector("[data-kik-variants]");
    if (!t || !e) return;
    let i;
    try {
      i = JSON.parse(e.textContent);
    } catch {
      return;
    }
    Array.isArray(i) && t.addEventListener("change", () => {
      const n = [...t.querySelectorAll("[data-kik-option]")].map(
        (r) => r.querySelector("[data-kik-option-input]:checked")?.value ?? null
      );
      for (const r of t.querySelectorAll("[data-kik-option]")) {
        const s = r.querySelector("[data-kik-option-input]:checked")?.value, c = r.querySelector("[data-kik-option-selected]");
        c && s && (c.textContent = s);
      }
      const o = i.find(
        (r) => n.every((s, c) => s === null || r.options[c] === s)
      );
      if (!o) {
        const r = this.querySelector("[data-kik-atc]");
        r && (r.disabled = !0, r.textContent = "Unavailable");
        return;
      }
      this.applyVariant(o);
    });
  }
  // Bundle selector (Figma 10564:241): row 1 is this product; rows 2+ are this product PLUS
  // extra accessory products. It deliberately does NOT touch the hero price. A native product
  // form can only post a single variant, and the theme's ajax cart reads that one `id`, so the
  // earlier "add extras, then replay the submit" hand-off silently lost the extras whenever the
  // theme intercepted the first submit. We now own the whole add for bundle rows: machine plus
  // every extra go up in ONE /cart/add.js call, then we send the shopper to the cart so the
  // full bundle is guaranteed to show. Machine-only rows fall through to the theme untouched.
  initBundle() {
    const t = this.querySelector("[data-kik-bundle]"), e = this.querySelector("[data-kik-buy] form"), i = e?.querySelector("[data-kik-atc]");
    if (!t || !e || !i) return;
    const n = (o) => {
      if (i.dataset.kikExtrasDone === "1") {
        delete i.dataset.kikExtrasDone;
        return;
      }
      const s = (t.querySelector("[data-kik-bundle-input]:checked")?.dataset.extraIds ?? "").split(",").map((a) => a.trim()).filter(Boolean);
      if (!s.length) return;
      o.preventDefault(), o.stopImmediatePropagation();
      const c = s.map((a) => ({ id: Number(a), quantity: 1 }));
      i.disabled = !0, fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: c })
      }).then((a) => {
        if (!a.ok) throw new Error("cart add failed");
        i.dataset.kikExtrasDone = "1", i.disabled = !1, i.click();
      }).catch((a) => {
        console.error("[kik-bundle] cart add failed", a), i.disabled = !1;
      });
    };
    i.addEventListener("click", n, !0), e.addEventListener("submit", n, !0);
  }
  // Shared by the variant picker and the bundle selector: point the buy form at `match`,
  // update the add-to-cart state, re-render the price block, and swap the gallery image.
  // Shopify money_format aware; shared by the hero price block and the sticky bar.
  formatMoney(t) {
    const e = window.Shopify?.money_format ?? "${{amount}}", i = (t / 100).toFixed(2);
    return e.replace(/\{\{\s*amount[^}]*\}\}/, i);
  }
  applyVariant(t) {
    const e = this.querySelector("[data-kik-variant-id]"), i = this.querySelector("[data-kik-atc]"), n = this.querySelector("[data-kik-price-now]"), o = this.querySelector("[data-kik-price-was]"), r = this.querySelector("[data-kik-price-save]"), s = (a) => this.formatMoney(a);
    e && (e.value = t.id), i && (i.disabled = !t.available, i.textContent = t.available ? i.dataset.kikAtcLabel ?? "ADD TO CART" : "Sold out"), n && (n.textContent = s(t.price));
    const c = t.compare_at_price > t.price;
    o && (o.hidden = !c, c && (o.textContent = s(t.compare_at_price))), r && (r.hidden = !c, c && (r.textContent = `SAVE ${s(t.compare_at_price - t.price)}`)), this.repaintBundle(t), this.selectVariantMedia(t), this.dispatchEvent(new CustomEvent("kik:variant", { detail: t }));
  }
  // Each bundle row's total is machine + extras. The machine is the LIVE variant, so when the
  // variant changes the row prices must follow — the same derivation the sticky bar uses
  // (data-extra-price/-compare hold the extras-only total per row). Mirrors the Liquid: the
  // row's compare line always exists and is toggled via `hidden`, so a variant change can move
  // a row on or off sale.
  repaintBundle(t) {
    const e = this.querySelector("[data-kik-bundle]");
    if (!e) return;
    const i = t.compare_at_price > t.price ? t.compare_at_price : t.price;
    for (const n of e.querySelectorAll("[data-kik-bundle-option]")) {
      const o = n.querySelector("[data-kik-bundle-input]"), r = n.querySelector("[data-kik-bundle-price]"), s = n.querySelector("[data-kik-bundle-compare]");
      if (!o || !r) continue;
      const c = Number(o.dataset.extraPrice) || 0, a = Number(o.dataset.extraCompare) || 0, p = t.price + c, k = i + a, u = k > p;
      r.textContent = this.formatMoney(p), s && (s.hidden = !u, u && (s.textContent = this.formatMoney(k)));
    }
  }
  // The gallery is the theme's own T4S/flickity slider (snippets/kik-product-gallery.liquid).
  // main-product.liquid's variant→media handler never runs for this standalone section, so
  // mirror the parts of it that matter (theme.min.js _updateMediaFilter / _switchMedia):
  // re-filter grouped media so the target slide is visible, then select the variant's
  // featured slide. selectCell takes the slide element directly (global.min.js queryCell),
  // so no fragile flickity-index math.
  selectVariantMedia(t) {
    const e = t.featured_media?.id;
    if (!e) return;
    const i = this.querySelector("[data-main-media]");
    if (!i || !i.classList.contains("flickityt4s-enabled")) return;
    const n = i.flickityt4s?.flkty ?? window.jQuery?.(i).data("flickityt4s");
    if (!n) return;
    const o = [...i.querySelectorAll("[data-main-slide]")];
    if (window.jQuery && o.some((c) => c.dataset.grname)) {
      const c = this.optionNames();
      let a = null, p = null;
      for (let k = 0; k < t.options.length; k++) {
        const u = (c[k] ?? "").toLowerCase(), m = t.options[k];
        if (!(!u || m == null) && o.some((f) => (f.dataset.grname || "").toLowerCase() === u)) {
          a = u, p = String(m).toLowerCase();
          break;
        }
      }
      if (a) {
        const k = o.filter(
          (u) => (u.dataset.grname || "").toLowerCase() === a && (u.dataset.grpvl || "").toLowerCase() === p
        );
        if (k.length) {
          for (const u of o) u.classList.add("is--media-hide");
          for (const u of k) u.classList.remove("is--media-hide");
          window.jQuery(i).trigger("update.flickityt4s");
        }
      }
    }
    const r = o.filter((c) => c.dataset.mediaId === String(e)), s = r.find((c) => c.offsetParent !== null) ?? r[0];
    s && n.selectCell(s, !1, !1);
  }
  // Option names in the product's option order (== variant.options order), read from the
  // picker's labels ("Colour:" → "Colour"). Used only to pair variant option values with the
  // gallery's grouped-media data-grname buckets.
  optionNames() {
    const t = this.querySelector("[data-kik-variant-picker]");
    return t ? [...t.querySelectorAll("[data-kik-option]")].map(
      (e) => (e.querySelector("p span")?.textContent ?? "").replace(/:\s*$/, "").trim()
    ) : [];
  }
  // Sticky add-to-cart (Figma 11025:3123 desktop / 11025:3140 mobile). A fixed bar that
  // reveals once the shopper reaches the bottom of the section, mirrors the hero's variant
  // and price, and proxies its click to the real buy-form button so the theme's ajax cart
  // and the bundle handler keep working unchanged. Variant state stays single-sourced: the
  // sticky select routes through applyVariant, which broadcasts "kik:variant" back so the
  // bar, the hero price, and the swatch picker never drift apart.
  initStickyAtc() {
    const t = this.querySelector("[data-kik-sticky]");
    if (!t) return;
    const e = this.querySelector("[data-kik-sticky-sentinel]"), i = t.querySelector("[data-kik-sticky-variant]"), n = t.querySelector("[data-kik-sticky-atc]"), o = t.querySelector("[data-kik-sticky-price-now]"), r = t.querySelector("[data-kik-sticky-price-was]"), s = t.querySelector("[data-kik-sticky-thumb]"), c = (d) => {
      if (!d) return d;
      try {
        const l = new URL(d, window.location.origin);
        return l.searchParams.set("width", "96"), l.href;
      } catch {
        return d;
      }
    }, a = this.querySelector("[data-kik-atc]"), p = this.querySelector("[data-kik-variant-id]"), k = this.querySelector("[data-kik-variant-picker]"), u = this.querySelector("[data-kik-bundle]");
    let m = [];
    try {
      m = JSON.parse(this.querySelector("[data-kik-variants]")?.textContent ?? "[]");
    } catch {
      m = [];
    }
    let f = m.find((d) => String(d.id) === String(p?.value)) ?? m[0] ?? null;
    const x = () => {
      const d = u?.querySelector("[data-kik-bundle-input]:checked");
      return {
        price: Number(d?.dataset.extraPrice) || 0,
        compare: Number(d?.dataset.extraCompare) || 0
      };
    }, S = () => {
      if (!f) return;
      const d = x(), l = f.price + d.price, h = (f.compare_at_price > f.price ? f.compare_at_price : f.price) + d.compare, b = h > l;
      o && (o.textContent = this.formatMoney(l)), r && (r.hidden = !b, b && (r.textContent = this.formatMoney(h)));
    };
    if (u?.addEventListener("change", S), i?.addEventListener("change", () => {
      const d = m.find((l) => String(l.id) === i.value);
      d && this.applyVariant(d);
    }), n?.addEventListener("click", () => {
      if (n.disabled) return;
      if (a && !a.disabled) {
        a.click();
        return;
      }
      const d = p?.value || i?.value;
      d && fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(d), quantity: 1 })
      }).then((l) => {
        l.ok && (window.location.href = "/cart");
      }).catch((l) => console.error("[kik-sticky] cart add failed", l));
    }), this.addEventListener("kik:variant", (d) => {
      const l = d.detail;
      l && (f = l, i && String(i.value) !== String(l.id) && (i.value = String(l.id)), s && l.featured_image?.src && (s.src = c(l.featured_image.src), s.alt = l.featured_image.alt || l.name || s.alt), S(), n && (n.disabled = !l.available), k?.querySelectorAll("[data-kik-option]").forEach((h, b) => {
        const g = l.options[b];
        if (g == null) return;
        const q = h.querySelector(`[data-kik-option-input][value="${CSS.escape(g)}"]`);
        q && (q.checked = !0);
        const E = h.querySelector("[data-kik-option-selected]");
        E && (E.textContent = g);
      }));
    }), e && "IntersectionObserver" in window) {
      const d = (h) => {
        t.classList.toggle("translate-y-full", !h), t.classList.toggle("pointer-events-none", !h), t.setAttribute("aria-hidden", h ? "false" : "true");
      }, l = new IntersectionObserver((h) => {
        for (const b of h)
          d(b.isIntersecting || b.boundingClientRect.top < 0);
      });
      l.observe(e), this.observers.push(l);
    }
    S();
  }
  // dev note: "Video: open pop up" + UGC videos. Media is torn down on every open and
  // close so nothing keeps playing behind the backdrop.
  initVideo() {
    const t = this.querySelector("[data-kik-video-modal]"), e = this.querySelector("[data-kik-video-slot]"), i = () => {
      if (e) {
        for (const r of e.querySelectorAll("video"))
          r.pause(), r.removeAttribute("src"), r.load();
        e.replaceChildren();
      }
    }, n = (r) => {
      if (!(!t || !e)) {
        i(), e.replaceChildren(r);
        for (const s of e.querySelectorAll("video, iframe"))
          s.style.width = "100%", s.style.height = "100%", s.tagName === "VIDEO" && (s.style.objectFit = "contain"), s.tagName === "IFRAME" && (s.style.border = "0");
        typeof t.showModal == "function" ? t.showModal() : t.setAttribute("open", "");
      }
    };
    for (const r of this.querySelectorAll("[data-kik-video-open]"))
      r.addEventListener("click", () => {
        const s = this.querySelector("[data-kik-video-tpl]");
        s && n(s.content.cloneNode(!0));
      });
    for (const r of this.querySelectorAll("[data-kik-ugc-open]"))
      r.addEventListener("click", () => {
        const { youtube: s, video: c } = r.dataset;
        if (s) {
          const a = document.createElement("iframe");
          a.src = this.toEmbedUrl(s), a.allow = "autoplay; encrypted-media; picture-in-picture", a.allowFullscreen = !0, a.setAttribute("frameborder", "0"), n(a);
        } else if (c) {
          const a = document.createElement("video");
          a.src = c, a.controls = !0, a.autoplay = !0, a.playsInline = !0, n(a);
        }
      });
    const o = () => {
      i(), typeof t?.close == "function" ? t.close() : t?.removeAttribute("open");
    };
    this.querySelector("[data-kik-video-close]")?.addEventListener("click", o), t?.addEventListener("close", i), t?.addEventListener("click", (r) => {
      r.target === t && o();
    });
  }
  toEmbedUrl(t) {
    const e = t.match(/[?&]v=([\w-]{11})/)?.[1] ?? t.match(/youtu\.be\/([\w-]{11})/)?.[1] ?? t.match(/embed\/([\w-]{11})/)?.[1];
    return e ? `https://www.youtube.com/embed/${e}?autoplay=1` : t;
  }
}
customElements.get("kik-product-main") || customElements.define("kik-product-main", A);
class v extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector("[data-kik-scroller]"), this.thumb = this.querySelector("[data-kik-thumb]"), !(!this.scroller || !this.thumb) && (this.update = this.update.bind(this), this.scroller.addEventListener("scroll", this.update, { passive: !0 }), this.observer = new ResizeObserver(this.update), this.observer.observe(this.scroller), this.update());
  }
  disconnectedCallback() {
    this.scroller?.removeEventListener("scroll", this.update), this.observer?.disconnect();
  }
  update() {
    const e = this.thumb.parentElement.clientWidth, { scrollWidth: i, clientWidth: n, scrollLeft: o } = this.scroller, r = i > 0 ? n / i : 1;
    if (r >= 1 || e === 0) {
      this.thumb.style.width = "0px";
      return;
    }
    const s = Math.max(e * r, M), c = i - n, a = c > 0 ? o / c : 0;
    this.thumb.style.width = `${s}px`, this.thumb.style.transform = `translateX(${a * (e - s)}px)`;
  }
}
const M = 24;
class I extends v {
}
class N extends v {
}
class _ extends v {
}
class O extends v {
}
customElements.get("kik-core-benefits") || customElements.define("kik-core-benefits", I);
customElements.get("kik-how-it-works") || customElements.define("kik-how-it-works", N);
customElements.get("kik-use-case") || customElements.define("kik-use-case", _);
customElements.get("kik-comparison") || customElements.define("kik-comparison", O);
class T extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')], this.panels = this.tabs.map((t) => this.querySelector(`#${CSS.escape(t.getAttribute("aria-controls"))}`)), this.media = [...this.querySelectorAll("[data-kik-tab-media]")], !(this.tabs.length < 2) && (this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this), this.addEventListener("click", this.onClick), this.addEventListener("keydown", this.onKeydown));
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.onClick), this.removeEventListener("keydown", this.onKeydown);
  }
  onClick(t) {
    const e = t.target.closest('[role="tab"]');
    e && this.select(this.tabs.indexOf(e));
  }
  onKeydown(t) {
    const e = this.tabs.indexOf(t.target.closest('[role="tab"]'));
    if (e === -1) return;
    const i = this.tabs.length - 1, n = {
      ArrowRight: e === i ? 0 : e + 1,
      ArrowLeft: e === 0 ? i : e - 1,
      Home: 0,
      End: i
    }[t.key];
    n !== void 0 && (t.preventDefault(), this.select(n), this.tabs[n].focus());
  }
  select(t) {
    this.tabs.forEach((e, i) => {
      const n = i === t;
      e.setAttribute("aria-selected", String(n)), e.tabIndex = n ? 0 : -1, this.panels[i]?.toggleAttribute("hidden", !n), this.media[i]?.toggleAttribute("hidden", !n);
    });
  }
}
customElements.get("kik-spec") || customElements.define("kik-spec", T);
const w = () => {
  C.ready = !0, document.documentElement.dataset.kikTheme = "ready";
};
window.KikTheme = C;
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", w, { once: !0 }) : w();
document.addEventListener("shopify:section:load", w);
